<template>
    <div>

        <div id="figures" v-if="location == 1">
            <img src="/assets/img/figures-g-green-hor.svg" class="figure girl-green" />
            <img src="/assets/img/figures-g-yellow-hor.svg" class="figure girl-yellow" />
            <img src="/assets/img/figures-g-b-hor.svg" class="figure girl-boy" />
            <img src="/assets/img/figures-b-g-hor.svg" class="figure boy-girl" />
        </div>

        <div id="figures" v-if="location == 2">
            <img src="/assets/img/figures-g-green-kus.svg" class="figure girl-green" />
            <img src="/assets/img/figures-g-yellow-kus.svg" class="figure girl-yellow" />
            <img src="/assets/img/figures-g-b-kus.svg" class="figure girl-boy" />
            <img src="/assets/img/figures-b-g-kus.svg" class="figure boy-girl" />
        </div>

        <section class="offer page-wrapper-inner" v-if="dataIsInit">
            <div class="block">
                <div>
                    <label class="subtitle horgen" v-if="location == 1">Horgen</label>
                    <label class="subtitle kuesnacht"  v-if="location == 2">Küsnacht</label>

                    <h2>Kindergarten</h2>
                    <p v-if="location==1">{{ trans.kinder.intro1_horgen[lang]}} </p>
                    <p v-if="location==1">{{ trans.kinder.intro2_horgen[lang]}} </p>
                    <p v-if="location==2">{{ trans.kinder.intro1_kuesnacht[lang] }} </p>
                    <p v-if="location==2">{{ trans.kinder.intro2_kuesnacht[lang] }} </p>

                    <p>{{ trans.kinder.choose_tue_thu[lang]}}</p>
                     <!-- <ul class="link-block">
                        <li><a href="#" class="more">{{ trans.global.organisation[lang] }} +</a></li>
                        <li><a href="#" class="more">{{ trans.global.terms[lang] }} +</a></li>
                    </ul> -->
                </div>

                <div v-if="dataIsInit" >

                    <div v-for="timetable in choosenSelections[0].timetables" :key="timetable.id" :style="timetable.name == '' ? 'display:none' : ''" v-bind:class="[timetable.disabled ? 'rangeslider' : ' active rangeslider' ]"  >
                        <label>{{ timetable.name }} </label>
                        <vue-slider
                            v-model="timetable.timeendmap"
                            :data="sliderConfig.data"
                            :marks="sliderConfig.markbyday[location][timetable.weekday]"
                            :tooltip="'none'"
                            :included="true"
                            :disabled="timetable.disabled"
                            :ref="timetable.weekday"
                            v-on:change="checkCondition(timetable.weekday)"
                        ></vue-slider>
                        <p v-if="!timetable.disabled" class="noflex rangeslider-info">{{ trans.kinder.sliderinfo[lang]}}</p>

                    </div>
                    <ul class="optionblock">
                        <li>
                            <ul class="block-list white">
                                <li >
                                    <h5 class="no-topmargin"><img src="/assets/img/icon-lunch.svg" /> {{ trans.global.hotluch_onwichdays[lang] }}</h5>
                                    <lunch-component v-if="renderLunch" ref="lunch" class="noflex" :trans="trans" :lang="lang"  :noindividual="location == 2" :options="lunchoptionsRelevant" :status-open="true"  :onlyDiDo="false" :service="lunchService" :selections="selections" :location="location" :session="session"
                                    @submited="importLunchdata" :labelAllDaysWithoutWe="true"
                                    ></lunch-component>
                                </li>
                            </ul>
                        </li>
                    </ul>

                    <div class="summarybox">
                        <label>{{ trans.global.chf_month_total[lang]}}:</label>
                        <em>{{ priceSummary | francs}}</em>
                    </div>

                    <div class="applicationbox" >

                        <p>{{ trans.global.c2a_finish[lang] }}</p>
                        <button class="btn  btnoutline" v-on:click="storeData(modulRelevantSelections,3,'pdf')">{{ trans.global.downloadpdf[lang] }}</button>
                        <button class="btn" v-if="appmode=='offer'" v-on:click="storeData(modulRelevantSelections,3,'app')">{{ trans.global.register[lang] }}</button>
                        <button class="btn" v-if="appmode=='change'" v-on:click="storeData(modulRelevantSelections,3,'app')">{{ trans.global.confirm[lang] }}</button>


<!--
                        <br><br>
                        <a v-if="appmode == 'offer' && location == 1" href="/daycare/horgen/1/offer" class="btn btnoutline" >{{ trans.global.daycare_btn[lang] }}</a>
                        <a v-if="appmode == 'change' && location == 1" href="/daycare/horgen/1/change" class="btn btnoutline" >{{ trans.global.daycare_btn[lang] }}</a>
                        <a v-if="appmode == 'offer' && location == 2" href="/daycare/kuesnacht/2/offer" class="btn btnoutline" >{{ trans.global.daycare_btn[lang] }}</a>
                        <a v-if="appmode == 'change' && location == 2" href="/daycare/kuesnacht/2/change" class="btn btnoutline" >{{ trans.global.daycare_btn[lang] }}</a> -->



                    </div>


                </div>
            </div>
        </section>


        <div class="teaser-wrapper">
            <h3 class="title"></h3>
            <div class="grid">
                 <div class="teaser">
                    <p>{{ trans.teaser.about_kin.text[lang] }}</p>
                    <a :href="trans.teaser.about_kin.link[location][lang]" target="_blank">{{ trans.teaser.about_kin.linktext[lang] }}</a>
                </div>
                <div class="teaser" v-if="location != 2">
                    <p>{{ trans.teaser.video_kin.text[lang] }}</p>
                    <a :href="trans.teaser.video_kin.link[location][lang]" target="_blank">{{ trans.teaser.video_kin.linktext[lang] }}</a>
                </div>
            </div>
        </div>


    </div>
</template>



<script>

    import * as helpers from "./helpers.js";
    import * as methods from "./methods.js";

    export default {

        data: function() {
            return  {
                renderLunch : true,
                days: [

                    { id: '', name: '', disabled: true }, // bug fix (app fails if 'mo' is first element)
                    { id: 'mo', name: this.trans.global.monday[this.lang], disabled: false },
                    { id: 'di', name: this.trans.global.tuesday[this.lang], disabled: false },
                    { id: 'mi', name: this.trans.global.wednesday[this.lang], disabled: true },
                    { id: 'do', name: this.trans.global.thursday[this.lang], disabled: false },
                    { id: 'fr', name: this.trans.global.friday[this.lang], disabled: false }

                ],

                lunchoptions:[
                    {id:'mo',label: this.trans.global.monday[this.lang], isActive: false},
                    {id:'di',label: this.trans.global.tuesday[this.lang], isActive: false},
                    {id:'do',label: this.trans.global.thursday[this.lang], isActive: false},
                    {id:'fr',label: this.trans.global.friday[this.lang], isActive: false}
                ],

                config:{
                    sectorIds: [ 3 , 5 ], // Kindergarten, Sonstiges
                    serviceIdFull: 14,
                    serviceIdMinus: 15,
                    serviceIdMinus2: 19,
                    serviceIdLunchs: 17,
                    defaultStart: { 1: '8:45' , 2: '9:00'},
                    defaultEnd: { 1: '15:45' , 2: '15:30'},
                    wednesdayEnd: { 1: '11:45' , 2: '11:45'},
                },
                choosenSelectionIds: [],
                mainservice: null,
                services: [],
                errors: [],
                selections: [],
                selectionsOrigin: [],
                dataIsInit: false,
                sliderConfig:{
                    markbyday: {
                        1 :
                            {
                                mo: {'0': '8:45','26': '11:45','37': '13:30','100':'15:45'},
                                di: {'0': '8:45','26': '11:45','37': '13:30','100':'15:45'},
                                mi: {'0': '8:45','28':'12:00'},
                                do: {'0': '8:45','26': '11:45','37': '13:30','100':'15:45'},
                                fr: {'0': '8:45','26': '11:45','37': '13:30','100':'15:45'},
                            },
                        2 :
                            {
                                mo: {'0': '9:00','26': '11:45','37': '13:30','100':'15:30'},
                                di: {'0': '9:00','26': '11:45','37': '13:30','100':'15:30'},
                                mi: {'0': '9:00','28':'12:00'},
                                do: {'0': '9:00','26': '11:45','37': '13:30','100':'15:30'},
                                fr: {'0': '9:00','26': '11:45','37': '13:30','100':'15:30'},
                            },
                    },
                    marks:  {
                        1: {'0': '8:45','26': '11:45','37': '13:30','100':'15:45'},
                        2: {'0': '9:00','26': '11:45','37': '13:30','100':'15:30'}
                    }
                }
            }
        },
        props: {
            session: {
                type: String,
                required: true
            },
            location: {
                type: Number,
                required: true
            },
            lang: {
                type: String,
                required: true
            },
            appmode: {
                type: String,
                required: true
            },
            trans: {
                type: Object,
                required: true
            },
        },
        computed: {

            lunchoptionsRelevant: function(){
                let app = this;
                var removeWE = [];
                 var reloadLunch = false;

                var noTimeBelow12 = true;

                for(var i = 0; i < app.choosenSelections[0].timetables.length; i++){
                    var t = app.choosenSelections[0].timetables[i].timeend.replace(":",".");
                    if(parseFloat(t) <= 12){
                        removeWE.push(app.choosenSelections[0].timetables[i].weekday);

                        var lunchserv = app.lunchoptions.filter(function(item) {
                            return item.id == app.choosenSelections[0].timetables[i].weekday;
                        });
                        if(lunchserv[0]) lunchserv[0].isActive = false;

                        // delete inactive lunch selection
                        if( app.selections)
                        {
                            for(var y = 0; y < app.selections.length; y++){
                                if( app.selections[y].timetables[0].weekday == app.choosenSelections[0].timetables[i].weekday ){
                                     app.selections.splice(y,1);
                                }
                            }
                        }
                    }
                    if(parseFloat(t) <= 12 && app.choosenSelections[0].timetables[i].weekday != "mi"){
                       noTimeBelow12 = false;
                    }
                }
                if(this.$refs["lunch"] && this.$refs["lunch"].modeAll && noTimeBelow12){
                    let missingDays = ['mo','di','do','fr'];
                    for(var y = 0; y < app.lunchSelections.length; y++){
                         for( var i = 0; i < missingDays.length; i++){
                            if ( missingDays[i] === app.lunchSelections[y].timetables[0].weekday) {
                                missingDays.splice(i, 1);
                            }
                        }
                    }
                    if(missingDays.length > 0 && missingDays.length < 4)
                    {
                        for(var q = 0; q < missingDays.length; q++){
                                let timetables = [];
                                let id = app.generateString(12);
                                timetables[0] = {
                                    id: app.generateString(12),
                                    weekday: missingDays[q],
                                    selection_id: id,
                                }
                                app.selections.push(
                                    {
                                        id: id,
                                        service_id: app.lunchService.id,
                                        service: app.lunchService,
                                        location_id: app.location,
                                        timetables: timetables,
                                        session_id: app.session
                                    }
                                );


                        }
                    }

                }

                if(reloadLunch){
                    //  this.renderLunch = false;
                    //     this.$nextTick(() => {
                    //         // Add the component back in
                    //         this.renderLunch = true;
                    //     });
                }

                var lunches =  app.lunchoptions.filter(function(item) {
                    return  removeWE.includes(item.id) === false;
                });


                return lunches;
            },

            lunchService: function () {
                let id = this.config.serviceIdLunchs;
                var service = this.services.filter(function(item) {
                    return item.id == id;
                });
                return service[0];
            },
            lunchSelections: function () {
                let app = this;
                return this.selections.filter(function(item) {
                    return item.service_id == app.config.serviceIdLunchs;
                });
            },
            modulRelevantSelections: function () {
                let app = this;
                return this.selections.filter(function(item) {
                    let found = app.services.find(element => element.id == item.service_id);
                    return found !== undefined
                });
            },
            choosenSelections: function () {
                let app = this;
                return this.selections.filter(function(item) {
                    return app.choosenSelectionIds.indexOf(item.id) !== -1;
                });
            },
            price: function () {
                let app = this;
                return app.choosenSelections[0].service.relevantPrice.price;
            },
            lunchPriceTotal: function () {
                var price = 0;
                for(var i = 0; i < this.lunchSelections.length; i++)
                {
                    price = price + this.lunchSelections[i].service.relevantPrice.price_brutto
                }
                return price
            },
            priceSummary: function () {
                return this.price + this.lunchPriceTotal
            }
        },
        mounted() {
            this.loadData();
        },
        methods: {
            loadData() {
                let app = this;
                // load for each sector the services
                axios.get('/api/services/bysectors/' + this.config.sectorIds.join() + '/' + this.location)
                .then(response => {
                    this.services = this.services.concat(response.data);
                    axios.get('/api/session/data/' + this.session )
                        .then(response => {

                            //vorübergehend deaktiviert
                            // this.selections = response.data.selections.filter(function(item) {
                            //     return item.location_id == app.location;
                            // });

                            this.selections = [];

                            this.selectionsOrigin = this.selections;
                            app.dataInit();
                            app.loadDayData( app.choosenSelections[0] );
                            setTimeout(function(){  app.setSliderData( app.choosenSelections[0] ) }, 20);

                        })
                        .catch(e => {
                            this.errors.push(e)
                        });

                })
                .catch(e => {
                    this.errors.push(e)
                });
            },

            dataInit() {

                let app = this;
                let selection = this.getSingleSelection( [ app.config.serviceIdFull, app.config.serviceIdMinus, app.config.serviceIdMinus2 ] );

                if(selection.length == 0){
                    selection[0] = app.createNewSelection(app.config.serviceIdFull);
                }
                if(selection.length > 1){
                    app.deleteMultipleSelections();
                }
                app.choosenSelectionIds.push( selection[0].id );
                app.dataIsInit = true;

            },


            checkCondition(ref)
            {



                  let app = this;

                  // only one half day possible
                  if(app.$refs[ref][0].getValue() != 100 && ref != 'mi')
                  {
                      for(let i = 0 ; i < app.days.length ; i++ ){
                          if(app.days[i].id != ref && app.days[i].id !='mi')
                          {
                              app.$refs[app.days[i].id][0].setValue(100);
                          }
                      }
                  }

                  // fix to prevant starttime
                  if(app.$refs[ref][0].getValue() == 0)
                  {
                     setTimeout(function(){ app.$refs[ref][0].setValue(26); }, 20);
                  }

                  // select the service (price relevant) for the current settings
                  app.mainservice = app.config.serviceIdFull;
                  for(let i = 0 ; i < app.days.length ; i++ ){
                      var time = app.$refs[app.days[i].id][0].getValue();
                      if(time != 100 && app.days[i].id != 'mi')
                      {
                          if(time == 26){
                              app.mainservice = app.config.serviceIdMinus2;
                          }
                          if(time == 37){
                              app.mainservice = app.config.serviceIdMinus;
                          }

                      }
                  }
                  let serv = null;
                  if(app.mainservice == app.config.serviceIdFull)
                  {
                      serv = app.services.filter(function(item) { return item.id == app.config.serviceIdFull});
                  }
                  if(app.mainservice == app.config.serviceIdMinus)
                  {
                      serv = app.services.filter(function(item) { return item.id == app.config.serviceIdMinus});
                  }
                  if(app.mainservice == app.config.serviceIdMinus2)
                  {
                      serv = app.services.filter(function(item) { return item.id == app.config.serviceIdMinus2});
                  }


                  app.choosenSelections[0].service = serv[0];
                  app.choosenSelections[0].service_id = serv[0].id;

                  // set endtime in timetable
                  for(let i = 0 ; i < app.choosenSelections[0].timetables.length ; i++ ){
                      if(app.choosenSelections[0].timetables[i].weekday == ref)
                      {
                          var timeKey = app.choosenSelections[0].timetables[i].timeendmap;
                         app.choosenSelections[0].timetables[i].timeend = app.sliderConfig.marks[app.location][timeKey];
                      }
                  }




            },

            ...helpers,
            ...methods,




        }

    }
</script>
